import { useDispatch, useSelector } from 'react-redux';

import enrollmentActions from '@redux/enrollment/actions';
import { RootState } from '@redux/reducer';

const { createUserEnrollFreeAction } = enrollmentActions;

const useCreateUserEnrollFree = () => {
  const dispatch = useDispatch();
  const { createUserEnrollFreeState } = useSelector((state: RootState) => ({
    createUserEnrollFreeState: state.Enrollment.get('createUserEnrollFree'),
  }));

  const { isLoading, isSuccess } = createUserEnrollFreeState;

  const resetUserEnrollFree = async () => {
    dispatch(createUserEnrollFreeAction.reset());
  };

  const createUserEnrollFree = async (courseId: number) => {
    dispatch(createUserEnrollFreeAction.request({ courseId }));
  };

  return {
    isLoading,
    isSuccess,
    createUserEnrollFree,
    resetUserEnrollFree,
  };
};

export default useCreateUserEnrollFree;
